import React from "react";
import GetHasStarta from "../../utils/UserFunctions/GetHasStarta";
const RequiredStar = (props) => {
  if (
    !props.arrangemang ||
    !props.arrangemang.avdelning ||
    !props.arrangemang.avdelning.id
  )
    return null;
  const hasStarta = GetHasStarta(props.arrangemang.avdelning.id);
  return (
    <span
      className="labelstar"
      style={
        props.starColor
          ? props.starColor
          : props.arrangemang.status > 0 && hasStarta
          ? { color: "#e52b20", fontSize: "18px", lineHeight: "1px" }
          : { color: "#ee9412", fontSize: "18px", lineHeight: "1px" }
      }
      title={props.description}
    >
      &#42;
    </span>
  );
};

export default RequiredStar;
